document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById('value');
  const yesButton = document.getElementById('article-vote-yes');
  const noButton = document.getElementById('article-vote-no');
  const articleUid = container.getAttribute('data-article-uid');
  const articleVotes = JSON.parse(localStorage.getItem('articleVotes')) || {};
  const savedVote = articleVotes[articleUid];

  if (savedVote) {
    if (savedVote === 'yes') {
      toggleButtonClasses(yesButton, noButton);
    } else if (savedVote === 'no') {
      toggleButtonClasses(noButton, yesButton);
    }
  }

  yesButton.addEventListener('click', function () {
    articleVotes[articleUid] = 'yes';
    localStorage.setItem('articleVotes', JSON.stringify(articleVotes));
    toggleButtonClasses(yesButton, noButton);
  });

  noButton.addEventListener('click', function () {
    articleVotes[articleUid] = 'no';
    localStorage.setItem('articleVotes', JSON.stringify(articleVotes));
    toggleButtonClasses(noButton, yesButton);
  });

  function toggleButtonClasses(activeButton, inactiveButton) {
    activeButton.classList.remove('text-bleu-mpf');
    activeButton.classList.add('bg-bleu-mpf', 'text-white');
    inactiveButton.classList.remove('bg-bleu-mpf', 'text-white');
    inactiveButton.classList.add('text-bleu-mpf');
  }
});
